import { z } from 'zod';
import { auditFieldsSchema, idSchema } from './common.js';
/**
 * Plano de contas hierárquico (receita / despesa).
 *
 * Junto com o centro de custo, forma o par obrigatório de todo lançamento:
 * o centro de custo diz ONDE gastou, a conta diz O QUE gastou.
 */
export const CHART_ACCOUNT_TYPES = ['RECEITA', 'DESPESA'];
export const chartAccountTypeSchema = z.enum(CHART_ACCOUNT_TYPES);
export const CHART_ACCOUNT_TYPE_LABELS = {
    RECEITA: 'Receita',
    DESPESA: 'Despesa',
};
export const CHART_ACCOUNT_NATURES = [
    'RECEITA_OPERACIONAL',
    'DEDUCAO',
    'CUSTO',
    'DESPESA_OPERACIONAL',
    'INVESTIMENTO',
    'FINANCEIRA',
    'IMPOSTO',
];
export const chartAccountNatureSchema = z.enum(CHART_ACCOUNT_NATURES);
export const CHART_ACCOUNT_NATURE_LABELS = {
    RECEITA_OPERACIONAL: 'Receita operacional',
    DEDUCAO: 'Dedução de receita',
    CUSTO: 'Custo',
    DESPESA_OPERACIONAL: 'Despesa operacional',
    INVESTIMENTO: 'Investimento (CAPEX)',
    FINANCEIRA: 'Financeira',
    IMPOSTO: 'Imposto e taxa',
};
export const chartAccountSchema = auditFieldsSchema.extend({
    id: idSchema,
    companyId: idSchema,
    code: z.string(),
    name: z.string(),
    type: chartAccountTypeSchema,
    nature: chartAccountNatureSchema,
    parentId: idSchema.nullable(),
    path: z.string(),
    level: z.number().int(),
    isAnalytic: z.boolean(),
    isActive: z.boolean(),
});
export const chartAccountInputSchema = z.object({
    code: z
        .string()
        .trim()
        .min(1, 'Informe o código')
        .max(30)
        .regex(/^[0-9A-Za-z.-]+$/, 'Use apenas letras, números, ponto e hífen'),
    name: z.string().trim().min(2, 'Informe o nome').max(120),
    type: chartAccountTypeSchema,
    nature: chartAccountNatureSchema,
    parentId: idSchema.optional().nullable(),
    isAnalytic: z.boolean().default(true),
    isActive: z.boolean().default(true),
});
/** Ver a nota em `cost-center.ts`: o `id` é o que dá nome ao `$ref` do OpenAPI. */
export const chartAccountTreeSchema = z
    .lazy(() => chartAccountSchema.extend({ children: z.array(chartAccountTreeSchema) }))
    .meta({ id: 'ChartAccountNode' });
//# sourceMappingURL=chart-account.js.map